/**
 * 만세력 조회 파라미터 초기값
 *
 * - 깊은복사하여 사용: ```(_.cloneDeep(INITIAL_PARAM_DATA))```
 */
export const INITIAL_PARAM_DATA = {
  // integrationBirth 추출 데이터
  year: '',
  month: '',
  day: '',
  hour: '',
  min: '',
  // 기본정보 (성별, 이름)
  gender: null,
  userName: '',
  // 생년월일시, 음력/윤년, 출생지역
  birth: null,
  birthTime: null,
  unknownTime: 'N',
  isLunar: false,
  isLeapYear: null,
  addressTxt: null,
  bornAreaId: null,
  // 옵션
  option1: true, // 야자시/조자시
  option2: true, // 입춘/동지
  option3: false,
  option4: true, // 한국시/동경시
  // 기본 param
  lang: 'KOR',
  langYN: 'N',
  userGroupId: null,
  shortly: false,
  blCheck: 'N',
};
